import React, { Component } from 'react';
import './Contact.css';

class CallToAction extends Component {
	state = {};
	render() {
		return (
			<section id="Contact" className="call-to-action text-white text-center">
				<div className="overlay" />
				<div className="container">
					<div className="row">
						<div className="col-xl-9 mx-auto">
							<h2 className="mb-4">To contact us, push this button!</h2>
						</div>
						<div className="col-12">
							<a className="contact-btn" href="mailto:oscar.stigz@gmail.com,oliver.kaisti@gmail.com,keinanen3@gmail.com">
								Send an email to us!
							</a>
						</div>
					</div>
				</div>
			</section>
		);
	}
}

export default CallToAction;
